import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const fetchAll = async () => (await request.getInstance()).get(API_ROUTES.interviewer.fetchAll);
export const remove = async id => (await request.getInstance()).delete(API_ROUTES.interviewer.byId.replace(':id', id));
export const newItem = async (id, data) => (await request.getInstance()).post(API_ROUTES.interviewer.byId.replace(':id', id), data);
export const editItem = async (id, data) => (await request.getInstance()).put(API_ROUTES.interviewer.byId.replace(':id', id), data);
export const close = async (id, data) => (await request.getInstance()).put(API_ROUTES.interviewer.closeInterview.replace(':id', id), data);
